import React from "react"
import autobind from "class-autobind"
import { relative } from "path"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IProps {
}

interface IState {
}

const subTitleClass = {
    textTransform: "uppercase",
    fontSize: "14pt",
    textAlign: "center",
    weight: "bold",
    marginBottom: 10,
}

const titleClass = {
    fontSize: "45pt",
    lineHeight: "1em",
    textAlign: "center",
    minWidth: "350px",
}

const dataSectionClass = {
    borderBottom: "1px #cccccc solid",
    marginBottom: 40,
    paddingBottom: 20,
}

const optimizationSavingsStyles = {
    color: "#7E06A2",
}

const productivityStyles = {
    color: "#02B79C",
}

const administrativeStyles ={
    color: "#0398F5",
}

export default class WaveGraph extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)

        this.state = {
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{width: "100%", textAlign: "left", position: "relative", top: -100}}>
                <div style={{position: "relative", left: 150, top: 150, fontWeight: "bold"}}>
                    <div style={{display: "grid", width: 300, alignItems: "center", gridTemplateColumns: "min-content auto"}}>
                        <div style={{gridRow: 1, gridColumn: 1, height: 40}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
                                <defs>
                                    <filter id="Path_8" x="0" y="0" width="45" height="45" filterUnits="userSpaceOnUse">
                                        <feGaussianBlur stdDeviation="3" result="blur"/>
                                        <feFlood floodOpacity="0.161"/>
                                        <feComposite operator="in" in2="blur"/>
                                        <feComposite in="SourceGraphic"/>
                                    </filter>
                                </defs>
                                    <g transform="matrix(1, 0, 0, 1, 0, 0)" style={{fill: "#7e06a2", filter: "url(#Path_8)"}}>
                                        <g id="Path_8-2" data-name="Path 8" transform="translate(9 6)">
                                            <path style={{stroke: "none"}} d="M 13.5 25.5 C 10.29469013214111 25.5 7.281219959259033 24.25177955627441 5.01471996307373 21.98527908325195 C 2.748219966888428 19.71878051757812 1.5 16.7053108215332 1.5 13.5 C 1.5 10.29469013214111 2.748219966888428 7.281219959259033 5.01471996307373 5.01471996307373 C 7.281219959259033 2.748219966888428 10.29469013214111 1.5 13.5 1.5 C 16.7053108215332 1.5 19.71878051757812 2.748219966888428 21.98527908325195 5.01471996307373 C 24.25177955627441 7.281219959259033 25.5 10.29469013214111 25.5 13.5 C 25.5 16.7053108215332 24.25177955627441 19.71878051757812 21.98527908325195 21.98527908325195 C 19.71878051757812 24.25177955627441 16.7053108215332 25.5 13.5 25.5 Z"/>
                                            <path style={{fill: "white"}} d="M 13.5 3 C 7.71027946472168 3 3 7.71027946472168 3 13.5 C 3 19.28972053527832 7.71027946472168 24 13.5 24 C 19.28972053527832 24 24 19.28972053527832 24 13.5 C 24 7.71027946472168 19.28972053527832 3 13.5 3 M 13.5 0 C 20.95584106445312 0 27 6.044160842895508 27 13.5 C 27 20.95584106445312 20.95584106445312 27 13.5 27 C 6.044160842895508 27 0 20.95584106445312 0 13.5 C 0 6.044160842895508 6.044160842895508 0 13.5 0 Z"/>
                                        </g>
                                </g>
                            </svg>
                        </div>
                        <div style={{gridRow: 1, gridColumn: 2}}>
                            STAFF OPTIMIZATION SAVINGS
                        </div>
                    </div>
                    <div style={{display: "grid", width: 300, alignItems: "center", gridTemplateColumns: "min-content auto"}}>
                        <div style={{gridRow: 1, gridColumn: 1, height: 40}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
                                <defs>
                                    <filter id="Path_8" x="0" y="0" width="45" height="45" filterUnits="userSpaceOnUse">
                                        <feGaussianBlur stdDeviation="3" result="blur"/>
                                        <feFlood floodOpacity="0.161"/>
                                        <feComposite operator="in" in2="blur"/>
                                        <feComposite in="SourceGraphic"/>
                                    </filter>
                                </defs>
                                    <g transform="matrix(1, 0, 0, 1, 0, 0)" style={{fill: "#05F2CD", filter: "url(#Path_8)"}}>
                                        <g id="Path_8-2" data-name="Path 8" transform="translate(9 6)">
                                            <path style={{stroke: "none"}} d="M 13.5 25.5 C 10.29469013214111 25.5 7.281219959259033 24.25177955627441 5.01471996307373 21.98527908325195 C 2.748219966888428 19.71878051757812 1.5 16.7053108215332 1.5 13.5 C 1.5 10.29469013214111 2.748219966888428 7.281219959259033 5.01471996307373 5.01471996307373 C 7.281219959259033 2.748219966888428 10.29469013214111 1.5 13.5 1.5 C 16.7053108215332 1.5 19.71878051757812 2.748219966888428 21.98527908325195 5.01471996307373 C 24.25177955627441 7.281219959259033 25.5 10.29469013214111 25.5 13.5 C 25.5 16.7053108215332 24.25177955627441 19.71878051757812 21.98527908325195 21.98527908325195 C 19.71878051757812 24.25177955627441 16.7053108215332 25.5 13.5 25.5 Z"/>
                                            <path style={{fill: "white"}} d="M 13.5 3 C 7.71027946472168 3 3 7.71027946472168 3 13.5 C 3 19.28972053527832 7.71027946472168 24 13.5 24 C 19.28972053527832 24 24 19.28972053527832 24 13.5 C 24 7.71027946472168 19.28972053527832 3 13.5 3 M 13.5 0 C 20.95584106445312 0 27 6.044160842895508 27 13.5 C 27 20.95584106445312 20.95584106445312 27 13.5 27 C 6.044160842895508 27 0 20.95584106445312 0 13.5 C 0 6.044160842895508 6.044160842895508 0 13.5 0 Z"/>
                                        </g>
                                </g>
                            </svg>
                        </div>
                        <div style={{gridRow: 1, gridColumn: 2}}>
                            PRODUCTIVITY SAVINGS
                        </div>
                    </div>
                    <div style={{display: "grid", width: 300, alignItems: "center", gridTemplateColumns: "min-content auto"}}>
                        <div style={{gridRow: 1, gridColumn: 1, height: 40}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
                                <defs>
                                    <filter id="Path_8" x="0" y="0" width="45" height="45" filterUnits="userSpaceOnUse">
                                        <feGaussianBlur stdDeviation="3" result="blur"/>
                                        <feFlood floodOpacity="0.161"/>
                                        <feComposite operator="in" in2="blur"/>
                                        <feComposite in="SourceGraphic"/>
                                    </filter>
                                </defs>
                                    <g transform="matrix(1, 0, 0, 1, 0, 0)" style={{fill: "#187AFD", filter: "url(#Path_8)"}}>
                                        <g id="Path_8-2" data-name="Path 8" transform="translate(9 6)">
                                            <path style={{stroke: "none"}} d="M 13.5 25.5 C 10.29469013214111 25.5 7.281219959259033 24.25177955627441 5.01471996307373 21.98527908325195 C 2.748219966888428 19.71878051757812 1.5 16.7053108215332 1.5 13.5 C 1.5 10.29469013214111 2.748219966888428 7.281219959259033 5.01471996307373 5.01471996307373 C 7.281219959259033 2.748219966888428 10.29469013214111 1.5 13.5 1.5 C 16.7053108215332 1.5 19.71878051757812 2.748219966888428 21.98527908325195 5.01471996307373 C 24.25177955627441 7.281219959259033 25.5 10.29469013214111 25.5 13.5 C 25.5 16.7053108215332 24.25177955627441 19.71878051757812 21.98527908325195 21.98527908325195 C 19.71878051757812 24.25177955627441 16.7053108215332 25.5 13.5 25.5 Z"/>
                                            <path style={{fill: "white"}} d="M 13.5 3 C 7.71027946472168 3 3 7.71027946472168 3 13.5 C 3 19.28972053527832 7.71027946472168 24 13.5 24 C 19.28972053527832 24 24 19.28972053527832 24 13.5 C 24 7.71027946472168 19.28972053527832 3 13.5 3 M 13.5 0 C 20.95584106445312 0 27 6.044160842895508 27 13.5 C 27 20.95584106445312 20.95584106445312 27 13.5 27 C 6.044160842895508 27 0 20.95584106445312 0 13.5 C 0 6.044160842895508 6.044160842895508 0 13.5 0 Z"/>
                                        </g>
                                </g>
                            </svg>
                        </div>
                        <div style={{gridRow: 1, gridColumn: 2}}>
                            ADMINISTRATIVE SAVINGS
                        </div>
                    </div>
                </div>                
                <svg xmlns="http://www.w3.org/2000/svg" width="1315.715" height="594.265" viewBox="0 0 100% 90%">
                    <defs>
                        <linearGradient id="linear-gradient" x1="0.345" y1="0.158" x2="0.829" y2="-0.16" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#4fa4ed" stopOpacity="0.937"/>
                        <stop offset="0.246" stopColor="#7226aa" stopOpacity="0.514"/>
                        <stop offset="1" stopColor="#0c3d7f" stopOpacity="0.031"/>
                        </linearGradient>
                        <linearGradient id="linear-gradient-2" x1="0.482" y1="-0.035" x2="0.829" y2="-0.16" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#d7effc" stopOpacity="0.271"/>
                        <stop offset="1" stopColor="#0c3d7f" stopOpacity="0.031"/>
                        </linearGradient>
                        <linearGradient id="linear-gradient-3" x1="0.601" y1="-0.204" x2="1.468" y2="0.33" gradientUnits="objectBoundingBox">
                        <stop offset="0" stopColor="#fcfcfc" stopOpacity="0.604"/>
                        <stop offset="1" stopColor="#f8fbff" stopOpacity="0.039"/>
                        </linearGradient>
                        <filter id="Path_9" x="71.107" y="546" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                        <filter id="Ellipse_2" x="400.107" y="546" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur-2"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur-2"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                        <filter id="Ellipse_3" x="400.107" y="511" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur-3"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur-3"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                        <filter id="Ellipse_5" x="400.107" y="360" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur-4"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur-4"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                        <filter id="Ellipse_2-2" x="722.107" y="395" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur-5"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur-5"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                        <filter id="Ellipse_3-2" x="722.107" y="244" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur-6"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur-6"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                        <filter id="Ellipse_5-2" x="722.107" y="129" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur-7"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur-7"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                        <filter id="Ellipse_3-3" x="1041.107" y="96" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur-8"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur-8"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                        <filter id="Ellipse_5-3" x="1041.107" y="0" width="45" height="45" filterUnits="userSpaceOnUse">
                        <feGaussianBlur stdDeviation="3" result="blur-9"/>
                        <feFlood floodOpacity="0.161"/>
                        <feComposite operator="in" in2="blur-9"/>
                        <feComposite in="SourceGraphic"/>
                        </filter>
                    </defs>
                    <g id="Group_112" data-name="Group 112" transform="translate(-590.893 -169)">
                        <g id="Group_111" data-name="Group 111" transform="translate(-9.107 -113.809)">
                        <g id="Group_27" data-name="Group 27" transform="translate(0 60)">
                            <path id="Path_2" data-name="Path 2" className="cls-1" d="M4551.678,2354s152.654-21.972,305.86-133.128c226.882-164.611,518.369-440.291,824.129-438.936,62.891.279,110.292-2.672,148.655,0-.852,168.371-.247,46.247,0,60.627.493,28.2,0,35.249,0,35.249l-1.62,477.246Z" transform="translate(-3936 -1545)"/>
                            <path id="Path_3" data-name="Path 3" className="cls-2" d="M4551.678,2231.3s254.143,32.995,408.971-54.82c151.566-85.964,382.425-419.218,689.488-420.824,1.321-.007,2.556-.008,3.792,0,178.786.62,149.082-2.543,176.309-3.021-.044,14.515,0,18.046,0,18.046v458.765Z" transform="translate(-3936 -1420.305)"/>
                            <path id="Path_4" data-name="Path 4" className="cls-3" d="M4551.678,2067.261s73.926,1.927,166.205,3.012c79.234.932,171.721,3.589,245.784-22.954,87.937-31.516,149.056-117.624,314.145-152.049,117.8-24.564,278.178-14.6,440.093-14.24,206.9.462,112.164,0,112.164,0l-1.39,190.1Z" transform="translate(-3936 -1258.653)"/>
                        </g>
                        <path id="Path_5" data-name="Path 5" className="cls-4" d="M0,0H1292.647" transform="translate(602.5 870.5)"/>
                        </g>
                        <g id="Group_33" data-name="Group 33" transform="translate(-220 -70)">
                        <path id="Path_10" data-name="Path 10" className="cls-5" d="M0,0,.089,189.721" transform="translate(904.5 634.5)"/>
                        <g className="cls-21" transform="matrix(1, 0, 0, 1, 810.89, 239)">
                            <g id="Path_9-2" data-name="Path 9" className="cls-6" transform="translate(80.11 552)">
                            <path className="cls-10" d="M 13.5 25.5 C 10.29469013214111 25.5 7.281219959259033 24.25177955627441 5.01471996307373 21.98527908325195 C 2.748219966888428 19.71878051757812 1.5 16.7053108215332 1.5 13.5 C 1.5 10.29469013214111 2.748219966888428 7.281219959259033 5.01471996307373 5.01471996307373 C 7.281219959259033 2.748219966888428 10.29469013214111 1.5 13.5 1.5 C 16.7053108215332 1.5 19.71878051757812 2.748219966888428 21.98527908325195 5.01471996307373 C 24.25177955627441 7.281219959259033 25.5 10.29469013214111 25.5 13.5 C 25.5 16.7053108215332 24.25177955627441 19.71878051757812 21.98527908325195 21.98527908325195 C 19.71878051757812 24.25177955627441 16.7053108215332 25.5 13.5 25.5 Z"/>
                            <path className="cls-11" d="M 13.5 3 C 7.71027946472168 3 3 7.71027946472168 3 13.5 C 3 19.28972053527832 7.71027946472168 24 13.5 24 C 19.28972053527832 24 24 19.28972053527832 24 13.5 C 24 7.71027946472168 19.28972053527832 3 13.5 3 M 13.5 0 C 20.95584106445312 0 27 6.044160842895508 27 13.5 C 27 20.95584106445312 20.95584106445312 27 13.5 27 C 6.044160842895508 27 0 20.95584106445312 0 13.5 C 0 6.044160842895508 6.044160842895508 0 13.5 0 Z"/>
                            </g>
                        </g>
                        </g>
                        <g id="Group_32" data-name="Group 32" transform="translate(-120 -80)">
                        <g id="Group_31" data-name="Group 31" transform="translate(-4)">
                            <g id="Group_30" data-name="Group 30" transform="translate(1124 498.5)">
                            <g id="Group_29" data-name="Group 29">
                                <line id="Line_11" data-name="Line 11" className="cls-5" y2="335.53" transform="translate(13.5)"/>
                                <g className="cls-20" transform="matrix(1, 0, 0, 1, -409.11, -249.5)">
                                <g id="Ellipse_2-3" data-name="Ellipse 2" className="cls-7" transform="translate(409.11 552)">
                                    <circle className="cls-10" cx="13.5" cy="13.5" r="13.5"/>
                                    <circle className="cls-12" cx="13.5" cy="13.5" r="12"/>
                                </g>
                                </g>
                                <g className="cls-19" transform="matrix(1, 0, 0, 1, -409.11, -249.5)">
                                <g id="Ellipse_3-4" data-name="Ellipse 3" className="cls-8" transform="translate(409.11 517)">
                                    <circle className="cls-10" cx="13.5" cy="13.5" r="13.5"/>
                                    <circle className="cls-12" cx="13.5" cy="13.5" r="12"/>
                                </g>
                                </g>
                                <g className="cls-18" transform="matrix(1, 0, 0, 1, -409.11, -249.5)">
                                <g id="Ellipse_5-4" data-name="Ellipse 5" className="cls-9" transform="translate(409.11 366)">
                                    <circle className="cls-10" cx="13.5" cy="13.5" r="13.5"/>
                                    <circle className="cls-12" cx="13.5" cy="13.5" r="12"/>
                                </g>
                                </g>
                            </g>
                            </g>
                        </g>
                        </g>
                        <g id="Group_42" data-name="Group 42" transform="translate(199 -80)">
                        <g id="Group_53" data-name="Group 53" transform="translate(-1)">
                            <g id="Group_30-2" data-name="Group 30" transform="translate(1124 384)">
                            <g id="Group_29-2" data-name="Group 29">
                                <line id="Line_11-2" data-name="Line 11" className="cls-5" y2="432.483" transform="translate(13.5 17.5)"/>
                                <g className="cls-17" transform="matrix(1, 0, 0, 1, -731.11, -135)">
                                <g id="Ellipse_2-4" data-name="Ellipse 2" className="cls-7" transform="translate(731.11 401)">
                                    <circle className="cls-10" cx="13.5" cy="13.5" r="13.5"/>
                                    <circle className="cls-12" cx="13.5" cy="13.5" r="12"/>
                                </g>
                                </g>
                                <g className="cls-16" transform="matrix(1, 0, 0, 1, -731.11, -135)">
                                <g id="Ellipse_3-5" data-name="Ellipse 3" className="cls-8" transform="translate(731.11 250)">
                                    <circle className="cls-10" cx="13.5" cy="13.5" r="13.5"/>
                                    <circle className="cls-12" cx="13.5" cy="13.5" r="12"/>
                                </g>
                                </g>
                                <g className="cls-15" transform="matrix(1, 0, 0, 1, -731.11, -135)">
                                <g id="Ellipse_5-5" data-name="Ellipse 5" className="cls-9" transform="translate(731.11 135)">
                                    <circle className="cls-10" cx="13.5" cy="13.5" r="13.5"/>
                                    <circle className="cls-12" cx="13.5" cy="13.5" r="12"/>
                                </g>
                                </g>
                            </g>
                            </g>
                        </g>
                        </g>
                        <g id="Group_43" data-name="Group 43" transform="translate(507 -80)">
                        <g id="Group_31-2" data-name="Group 31">
                            <g id="Group_30-3" data-name="Group 30" transform="translate(1134 255)">
                            <g id="Group_29-3" data-name="Group 29">
                                <line id="Line_11-3" data-name="Line 11" className="cls-5" y2="565.414" transform="translate(13.5 13.5)"/>
                                <g className="cls-14" transform="matrix(1, 0, 0, 1, -1050.11, -6)">
                                <g id="Ellipse_3-6" data-name="Ellipse 3" className="cls-8" transform="translate(1050.11 102)">
                                    <circle className="cls-10" cx="13.5" cy="13.5" r="13.5"/>
                                    <circle className="cls-12" cx="13.5" cy="13.5" r="12"/>
                                </g>
                                </g>
                                <g className="cls-13" transform="matrix(1, 0, 0, 1, -1050.11, -6)">
                                <g id="Ellipse_5-6" data-name="Ellipse 5" className="cls-9" transform="translate(1050.11 6)">
                                    <circle className="cls-10" cx="13.5" cy="13.5" r="13.5"/>
                                    <circle className="cls-12" cx="13.5" cy="13.5" r="12"/>
                                </g>
                                </g>
                            </g>
                            </g>
                        </g>
                        </g>
                    </g>
                </svg>
            </div>
        )
    }
}